import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Loader from "components/Loader/index";
import GridWrapper from "custom-hooks/GridWrapper";
import { setApi } from "reducers/grid";
// import downloadCSV from "actions/downloadCSV";
// import tabsParams from "constants/tabsParams";
import { get } from "lodash";
import { withTranslation } from "react-i18next";
import permissions, { checkPermissions } from "../../../config/permissions";

import { extractCustomerFromState } from "helpers";


const mapStateToProps = (state, props) => {
    const {
        match: { url },
    } = props;

    return {
        grids: state.grid,
        tabs: state.tabs,
        // modificationCount: get(state, `customer.persons[${props.match.params.id}].contactPersonModificationCount`),
        // modificationCount: get(contactPerson, 'contactPersonModificationCount'),
        isHistoryView: checkPermissions(permissions.HistoryOperations.view_history),
        liveSavingInProcess: state.customer.liveSavingInProcess,
    };
};

const ContactPersonObjectsList = props => {
    const {
        t,
        grids,
        updateApiGrid,
        customerId,
        liveSavingInProcess,
        match: {
            params: { id: contactPersonId, serviceId, appealId, orderId, resourceId },
        },
    } = props;

    const [isLiveSaving, setIsLiveSaving] = useState(false);
    const [needRefresh, setNeedRefresh] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    const itemId = serviceId || appealId || orderId || resourceId;
    // console.log({props});
    const init = {
        key: "person_link",
        extra: itemId ? `${itemId}_${customerId}.${contactPersonId}` : `person_${customerId}.${contactPersonId}`,
        query: "?",
        personId: contactPersonId,
    };

    const gridKey = `${init.key}_${init.path || init.extra || ""}`;

    const [loadingState, setLoadingState] = useState(true);

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    // function onGridExport() {
    // 	onGridExport
    //     console.log("*** EXPORT CONTACT PERSON ***");
    //     const appealFields = Object.entries(tabsParams(t).filter).reduce((acc, [key, value]) => {
    //         const nameParts = [key];
    //         if (value.objectField) nameParts.push(value.objectField);

    //         acc[nameParts.join(".")] = value.name;

    //         return acc;
    //     }, {});

    //     const requestData = {
    //         fields: appealFields,
    //         customerId,
    //         // contactPersonId: contactPerson && contactPerson.id,
    //         start: null,
    //         limit: null,
    //     };

    //     if (contactPersonId) {
    //         requestData.contactPersonId = contactPersonId;
    //     }

    //     // const grid = isContactPerson ? contactPersonAppealsGrid : customerAppealsGrid;
    //     const grid = grids && grids[gridKey];
    //     const gridSort = get(grid, "params.sort");
    // 	console.log({grid, gridSort, grids});

    //     if (gridSort && gridSort.field && gridSort.order) {
    //         requestData["sort"] = [
    //             {
    //                 property: gridSort.field,
    //                 direction: gridSort.order.toUpperCase(),
    //             },
    //         ];
    //     }

    //     downloadCSV({ requestData, key: "appeal_customer_csv" });
    // }

    const onSelectItem = item => {
        const { subTab } = props.match.params;
        if (subTab === "link") {
            return props.history.push(`/customer/${item.entityId}/person/${props.match.params.id}/link`);
        } else return null;
    };

    useEffect(() => {
        if (customerId) {
            updateApiGrid({ customerId, contactPersonId }, gridKey);
            setIsMounted(true);
        }
    }, [customerId, contactPersonId]);

    useEffect(() => {
        if (liveSavingInProcess[contactPersonId]) {
            setIsLiveSaving(true);
        } else {
            setIsLiveSaving(false);
        }
    }, [liveSavingInProcess]);

    useEffect(() => {
        if (!isLiveSaving && isMounted) {
            setNeedRefresh(true);
        }
    }, [isLiveSaving]);

    useEffect(() => {
        if (needRefresh) {
            updateApiGrid({ customerId, contactPersonId }, gridKey);
            setNeedRefresh(false);
        }
    }, [needRefresh]);

    return (
        <div className="contentWrapper without-top-border">
            <div className="customer-ordering-grid">
                {loadingState && <Loader />}
                <GridWrapper
                    tuner={() => init}
                    initUpdate={false}
                    gridParams={{
                        selectItem: onSelectItem,
                    }}
                    // destroyOnUnmount
                    onStart={onStart}
                    onFinish={onFinish}
					fieldsLsCacheKey={`customer_page_person_link`}
					sortFieldsLsCacheKey={`customer_page_${gridKey}`}
                    // onGridExport={() => onGridExport({t, customerId, contactPersonId, grid: grids[gridKey]})}
                />
            </div>
        </div>
    );
};

export default withTranslation()(
    connect(mapStateToProps, { updateApiGrid: setApi })(withRouter(ContactPersonObjectsList))
);
